module.exports = __webpack_public_path__ + "img/enak.43a9fb8c.png";